var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Welcome "+_vm._s(_vm.currentUserName)+"!")]),_c('div',[_c('play-dates-list')],1),_c('play-date-map'),_c('pet-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }